import React, { useState, useEffect } from "react";
import DecoTopDemo1 from "./dashboard/images/Deco-top-demo1.png";
import DecoTopDemo3 from "./dashboard/images/Deco-right-demo3.png";
import DecoTopDemo2 from "./dashboard/images/Deco-top-demo2.png";
import DecoRightDemo from "./dashboard/images/Deco-right-demo.png";
import DecoTopDemo4 from "./dashboard/images/Deco-right-demo4.png";
import DecoTopDemo5 from "./dashboard/images/Deco-right-demo5.png";
import DecoTopDemo6 from "./dashboard/images/Deco-right-demo6.png";
import { api } from "api";
import { ToastContainer, toast } from 'react-toastify'; // Correct import
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for styling
import { Navbar, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

export default function DemoRegisterPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Dynamically add Tailwind CSS
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/tailwind.css";
    link.id = "tailwindcss-demo";
    document.head.appendChild(link);

    // Cleanup: remove Tailwind CSS when component unmounts
    return () => {
      const existing = document.getElementById("tailwindcss-demo");
      if (existing) existing.remove();
    };
  }, []);

  const [form, setForm] = useState({ name: "", mobile: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Send data to the backend using axios
      const response = await api.post('demoRequest.php', {
        name: form.name,
        email: form.email,
        phone_number: form.mobile, // Ensure this matches your backend
        message: form.message,
      });

      if (response.data.status === 'success') {
        setSubmitted(true);
        setForm({ name: "", mobile: "", email: "", message: "" });
        toast.success("Demo request submitted successfully!"); // Show toast on success
        setTimeout(() => setSubmitted(false), 3000);
      } else {
        // Handle error (e.g., show a message to the user)
        console.error(response.data.message);
        toast.error("Error submitting the demo request."); // Show error toast
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      toast.error("An error occurred while submitting the form."); // Show error toast
    }
    setLoading(false);
  };

  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
      const onScroll = () => setIsScrolled(window.scrollY > 20);
      window.addEventListener("scroll", onScroll);
      return () => window.removeEventListener("scroll", onScroll);
    }, []);

  return (
    <div className="min-h-screen bg-black relative flex flex-col items-center justify-start overflow-x-hidden overflow-y-hidden" style={{ background: 'white' }}>
      {loading && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          background: 'rgba(255,255,255,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <svg className="animate-spin h-16 w-16 text-[#CF617C]" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"/>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
          </svg>
        </div>
      )}
        <ToastContainer /> 
        <Navbar
                    className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 py-0  ${
                      isScrolled
                        ? "backdrop-blur-md bg-gray-100 shadow-md text-black"
                        : " bg-gray-100 text-black"
                    } border-0`}
                    style={{ border: "none" }}
                    blurred={true}
                    fullWidth={true}
                    shadow={false}
                  >
                    <div className="container mx-auto flex items-center justify-between ">
                      <img
                        src={require("./dashboard/images/AECP_logo.png")}
                        alt="AECP Logo"
                        style={{ height: "90px", width: "auto", marginRight: "16px", cursor: "pointer" }}
                        onClick={() => navigate("/")}
                      />
                      {/* LOGO left-aligned */}
                      <div className="flex-1 flex items-center">
                        {/* <Typography
                          variant="h5"
                          className={`text-white font-bold tracking-wider ${
                            isScrolled ? "text-black" : "text-white"
                          }`}
                        >
                          LOGO
                        </Typography> */}
                      </div>
                      {/* Hamburger Icon for mobile */}
                      <button
                        className="lg:hidden text-black focus:outline-none"
                        onClick={() => setMobileMenuOpen(true)}
                        aria-label="Open menu"
                      >
                        <Bars3Icon className="w-7 h-7" />
                      </button>
                      {/* Nav links centered (desktop only) */}
                      <div
                        className={`flex-1 hidden lg:flex justify-center gap-8 ${
                          isScrolled ? "text-black" : "text-black"
                        }`}
                      >
                        {[
                          { label: "About Us", to: "/#aboutus" },
                          { label: "Features", to: "/#features" },
                          { label: "Blogs", to: "/#blogs" },
                          { label: "FAQs", to: "/#faqs" },
                          { label: "Contact Us", to: "/#contactus" },
                        ].map((item) => (
                          <a
                            key={item.label}
                            href={item.to}
                            className={`text-black font-medium hover:text-[#E08681] transition whitespace-nowrap`}
                            onClick={e => {
                              e.preventDefault();
                              window.location.href = item.to;
                            }}
                          >
                            {item.label}
                          </a>
                        ))}
                      </div>
                      {/* Login button right-aligned and smaller (desktop only) */}
                      <div className="flex-1 hidden lg:flex justify-end gap-2">
                        <Button
                          className="px-3 py-1.5 rounded-md font-semibold text-sm shadow-none min-w-0 h-9 bg-[#E08681]"
                          onClick={() => navigate("/company-register")}
                        >
                          Register
                        </Button>
                        <Button
                          className="px-4 py-1.5 rounded-md font-semibold text-sm shadow-none min-w-0 h-9 bg-[#E08681]"
                          style={{ minWidth: "80px" }}
                          onClick={() => navigate("/login")}
                        >
                          Login
                        </Button>
                      </div>
                    </div>
                    {/* Mobile Menu Drawer */}
                    {mobileMenuOpen && (
                      <div
                        className="fixed inset-0 z-[999] bg-black/40 lg:hidden"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <div
                          className="absolute top-0 right-0 w-4/5 max-w-xs h-full bg-pink-100 shadow-lg flex flex-col p-4  gap-6 overflow-y-auto"
                          onClick={(e) => e.stopPropagation()}
                          style={{ minHeight: "100vh" }}
                        >
                          <div className="flex justify-between items-center mb-4">
                          <img
                              src={require("./dashboard/images/AECP_logo.png")}
                              alt="AECP Logo"
                              style={{ height: "90px", width: "auto", marginRight: "16px" }}
                            />
                            <button
                              onClick={() => setMobileMenuOpen(false)}
                              aria-label="Close menu"
                            >
                              <XMarkIcon className="w-7 h-7 text-white" />
                            </button>
                          </div>
                          <nav className="flex flex-col gap-4 items-center">
                            {["About Us", "Features", "Blogs", "FAQs", "Contact Us"].map(
                              (item, idx) => (
                                <a
                                  key={item}
                                  href={`#${item.toLowerCase().replace(/ /g, "")}`}
                                  className="text-white font-medium text-lg py-2 px-2 rounded hover:bg-[#13c9a7]/20 transition"
                                  onClick={() => setMobileMenuOpen(false)}
                                >
                                  {item}
                                </a>
                              )
                            )}
                          </nav>
                          <button className="mt-4 w-full bg-[#E08681] text-white font-semibold rounded-md py-2"
                             onClick={() => {
                              setMobileMenuOpen(false);
                              navigate("/company-register");
                            }}
                          >
                            Register
                          </button>
                          <button className="mt-4 w-full bg-[#E08681] text-white font-semibold rounded-md py-2"
                             onClick={() => {
                              setMobileMenuOpen(false);
                              navigate("/login");
                            }}
                          >
                            Login
                          </button>
                        </div>
                      </div>
                    )}
                  </Navbar>
      {/* Decorative Images */}
      <img src={DecoTopDemo3} alt="deco1" className="hidden md:block pointer-events-none select-none absolute left-0 bottom-[50%] w-[350px] max-w-[40vw] z-0"  />
      <img src={DecoTopDemo2} alt="deco1" className="pointer-events-none select-none absolute left--5 md:left-0 xl:bottom-[76%] w-[550px] max-w-[60vw] z-0"  />
      <img src={DecoTopDemo2} alt="deco1" className="pointer-events-none select-none absolute left-[15%] xl:bottom-[76%] w-[550px] max-w-[60vw] z-0"/>
      <img src={DecoTopDemo2} alt="deco1" className=" md:hidden pointer-events-none select-none absolute right-0 xl:bottom-[76%] w-[550px] max-w-[60vw] z-0"  />
      <img src={DecoTopDemo2} alt="deco1" className=" md:hidden pointer-events-none select-none absolute left-[15%] xl:bottom-[76%] w-[550px] max-w-[60vw] z-0"/>
      <img src={DecoRightDemo} alt="deco1" className="hidden md:block pointer-events-none select-none absolute right-[7%] bottom-[58%] w-[350px] max-w-[40vw] z-3 "  style={{transform: 'translate(30%,30%)'}}/>
      {/* <img src={DecoTopDemo2} alt="deco2" className="pointer-events-none select-none absolute right-0 top-0 w-[350px] max-w-[40vw] z-0" style={{transform: 'translate(30%,-30%)'}} />
      <img src={DecoRightDemo} alt="deco3" className="pointer-events-none select-none absolute right-0 bottom-0 w-[350px] max-w-[40vw] z-0" style={{transform: 'translate(30%,30%)'}} /> */}
      <div className="w-full flex flex-col items-center pt-16 pb-0 px-2 relative z-10">
        <div className="flex flex-col items-center md:mt-5 mb-5">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-2 text-black tracking-wide ">Request a Demo</h2>
            <p className="text-center text-gray-400  text-base">Please enter your details, we'll get back to you!</p>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4 w-full md:p-24 md:pb-10 md:pt-10">
          <div className="flex flex-col gap-1 w-[70%] mx-auto">
            <label className="font-semibold text-lg text-black flex items-center gap-1 mb-2">Name <span className="text-[#CF617C] text-xl">*</span></label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Enter your name"
              required
              className=" w-full mx-auto rounded-lg border-none bg-black shadow-md px-3 py-4 text-base focus:ring-2 focus:ring-[#CF617C] outline-none placeholder-gray-400" style={{background: 'white'}}
            />
          </div>
          <div className="flex flex-col gap-1 w-[70%] mx-auto">
            <label className="font-semibold text-lg text-black flex items-center gap-1 mb-2">Mobile Number <span className="text-[#CF617C] text-xl">*</span></label>
            <input
              type="tel"
              name="mobile"
              value={form.mobile}
              onChange={handleChange}
              placeholder="Enter mobile number"
              required
              className=" w-full mx-auto rounded-lg border-none bg-black shadow-md px-3 py-4 text-base focus:ring-2 focus:ring-[#CF617C] outline-none placeholder-gray-400" style={{background: 'white'}}
            />
          </div>
          <div className="flex flex-col gap-1 w-[70%] mx-auto">
            <label className="font-semibold text-lg text-black flex items-center gap-1 mb-2">Email Address <span className="text-[#CF617C] text-xl">*</span></label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
              className=" w-full mx-auto rounded-lg border-none bg-black shadow-md px-3 py-4 text-base focus:ring-2 focus:ring-[#CF617C] outline-none placeholder-gray-400" style={{background: 'white'}}
            />
          </div>
          <div className="flex flex-col gap-1 w-[70%] mx-auto">
            <label className="font-semibold text-lg text-black flex items-center gap-1 mb-2">Write a Message</label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              placeholder="Start typing...."
              rows={3}
              className=" w-full mx-auto rounded-lg border-none bg-black shadow-md px-3 py-4 text-base focus:ring-2 focus:ring-[#CF617C] outline-none placeholder-gray-400 resize-none" style={{background: 'white'}}
            />
          </div>
          <div className="flex justify-center mt-2 items-center">
            <button
              type="submit"
              className="bg-[#CF617C] text-white font-medium text-lg rounded-lg px-12 py-3 shadow-md hover:bg-pink-700 transition-all duration-200 z-20"
              style={{ minWidth: '180px' }}
            >
              Request
            </button>
          </div>
          {submitted && (
            <div className="text-green-600 text-center font-semibold mt-2">Demo request submitted!</div>
          )}
        </form>
        <img src={DecoTopDemo4} alt="deco1" className="pointer-events-none select-none absolute left-[8%] bottom--4 w-[550px] max-w-[40vw] z-0"  />
        <img src={DecoTopDemo5} alt="deco1" className="pointer-events-none select-none absolute left-[30%] bottom--4 w-[550px] max-w-[50vw] z-0"  />
        <img src={DecoTopDemo6} alt="deco1" className="pointer-events-none select-none absolute left-[60%] bottom--4 w-[550px] max-w-[40vw] z-0"  />
      </div>
    </div>
  );
} 